import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Resume {
  id: string;
  name: string;
  
  // 基本信息
  gender?: string;
  age?: number;
  birthday?: string;
  ethnic?: string;
  political_status?: string;
  marital_status?: string;
  height?: number;
  weight?: number;
  nationality?: string;
  id_card?: string;
  native_place?: string;
  hukou_addr?: string;
  addr?: string;
  city?: string;
  postal_code?: string;
  
  // 联系方式
  phone?: string;
  email?: string;
  fixed_line_phone?: string;
  inter_phone?: string;
  qq?: string;
  wechat?: string;
  linkedin_url?: string;
  
  // 职位相关
  position?: string;
  current_company?: string;
  current_position?: string;
  current_status?: string;
  current_salary?: string;
  expected_salary?: string;
  location?: string;
  
  // 教育背景
  highest_education?: string;
  graduation_school?: string;
  major?: string;
  minor?: string;
  graduation_year?: number;
  dept?: string;
  gpa?: string;
  
  // 工作经验
  years_of_experience?: number;
  work_year?: number;
  start_work_time?: string;
  industry?: string;
  
  // 求职意向
  job_search_status?: string;
  available_date?: string;
  preferred_industry?: string[];
  preferred_position?: string;
  preferred_location?: string[];
  preferred_company_type?: string;
  work_mode_preference?: string;
  overtime_acceptance?: string;
  travel_acceptance?: string;
  
  // 技能与技能
  skills?: string[];
  certifications?: string[];
  computer_certs?: string[];
  awards?: string[];
  
  // 语言能力
  language_skills?: Record<string, string>;
  lang_certs?: Array<{lang: string; cert: string; score?: number; date?: string}>;
  
  // 项目经历
  projects?: Array<{name: string; position: string; start_date: string; end_date: string; desc?: string}>;
  
  // 培训经历
  trainings?: Array<{org: string; subject: string; start_date: string; end_date: string; cert?: string}>;
  
  // 实践经历
  practices?: Array<{name: string; role: string; start_date: string; end_date: string; desc?: string}>;
  
  // 其他信息
  self_evaluation?: string;
  source?: string;
  referrer?: string;
  notes?: string;
  avatar_url?: string;
  
  // 简历信息
  resume_file_name?: string;
  resume_lang_type?: string;
  resume_source?: string;
  resume_id?: string;
  resume_update_time?: string;
  
  // 简历内容文本
  resume_content?: {
    text?: string;
    basic_info?: string;
    job_intention?: string;
    advantages?: string;
    career_profile?: string;
    contact?: string;
    education?: string;
    career?: string;
    project?: string;
    skill?: string;
    self_evaluation?: string;
    award?: string;
    language?: string;
    certification?: string;
    training?: string;
    hobby?: string;
  };
  
  // 原始解析结果（jsonb）
  raw_response?: any;
  
  created_at?: string;
  updated_at?: string;
}

export interface ResumeEducation {
  id: string;
  resume_id: string;
  school: string;
  degree?: string;
  major?: string;
  minor?: string;
  dept?: string;
  start_date?: string;
  end_date?: string;
  location?: string;
  courses?: string[];
  gpa?: string;
  relative_rank?: string;
  abs_rank?: string;
  description?: string;
  tags?: string[];
  school_info?: {
    country?: string;
    tags?: string[];
    rank?: number;
    qs_rank?: number;
  };
}

export interface ResumeWork {
  id: string;
  resume_id: string;
  company: string;
  position?: string;
  position_type?: string;
  nature?: string;
  dept?: string;
  start_date?: string;
  end_date?: string;
  duration?: string;
  salary?: string;
  location?: string;
  why_leave?: string;
  report_to?: string;
  company_desc?: string;
  company_nature?: string;
  industry?: string;
  stuff_size?: string;
  subordinate?: string;
  description?: string;
  skills?: string[];
}

export interface TalentTag {
  id: string;
  resume_id: string;
  tag_name: string;
  tag_type: string;
  created_at?: string;
}

export interface TalentStatusHistory {
  id: string;
  resume_id: string;
  status: string;
  project_id?: string;
  notes?: string;
  created_by?: string;
  created_at?: string;
}

export interface TalentCommunication {
  id: string;
  resume_id: string;
  communication_type: string;
  content?: string;
  summary?: string;
  created_by?: string;
  created_at?: string;
}
